import { Autocomplete, styled } from '@mui/material';
import { SlimUser } from 'api';

const StyledUserAutocomplete = styled(Autocomplete<SlimUser, false, false, false>)(() => ({
  minWidth: 200,
}));

const userAutocompletePopperStyles = {
  '& .MuiAutocomplete-paper': {
    minWidth: '350px !important',
    maxWidth: '450px !important',
  },
  '& .MuiAutocomplete-option': {
    whiteSpace: 'normal',
    wordBreak: 'break-word',
    overflowWrap: 'break-word',
  },
};

const userAutocompleteSlotProps = {
  popper: {
    sx: userAutocompletePopperStyles,
  },
};

export { StyledUserAutocomplete, userAutocompleteSlotProps };

